import { render, staticRenderFns } from "./OfflineRecord.vue?vue&type=template&id=a8047506&scoped=true&"
import script from "./OfflineRecord.vue?vue&type=script&lang=js&"
export * from "./OfflineRecord.vue?vue&type=script&lang=js&"
import style0 from "./OfflineRecord.vue?vue&type=style&index=0&id=a8047506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8047506",
  null
  
)

export default component.exports